import React, { Component } from 'react'
import copy from 'copy-to-clipboard'
import formatUnicorn from 'utils/formatUnicorn'
import autosize from 'autosize'
import DOMPurify from 'dompurify'
import withBackend from 'utils/withBackend'

const codes = {
  v2: `<!-- BT tag -->
  <script>(function(w, t, h, oid) { var s='script',o='_Bt',e,n;e=t.createElement(s);e.async=1;e.src=[h,'embed.js'].join('');w[o]=w[o]||function(){(w[o]._e=w[o]._e||[]).push(arguments)};w[o]._h=h;n=t.getElementsByTagName(s)[0];n.parentNode.insertBefore(e,n);w[o]._BtOId = oid;})(window,document,'{backend}','{id}');</script>
  <div id="BtContent"></div>
  <!-- BT tag -->`,
}

class Code extends Component {
  componentDidMount() {
    if (this.code) {
      autosize(this.code)
    }
  }

  setCode = (el) => {
    this.code = el
  }

  selectAll = () => {
    if (this.code) {
      this.code.select()
    }
  }

  copyHandler = (str) => {
    const { onCopy } = this.props
    copy(str)
    onCopy('Embed code copied to clipboard', 'DEFAULT')
  }


  render() {
    const {
      version,
      id,
      backend,
      locale = undefined,
    } = this.props

    const idPath = locale && locale !== 'en' ? `${locale}/${id}` : id

    const code = formatUnicorn(codes[version], { id: DOMPurify.sanitize(idPath), backend: DOMPurify.sanitize(backend) })

    return (
      <div className="embed">
        <textarea
          defaultValue={code}
          ref={el => (this.setCode(el))}
          onFocus={this.selectAll}
          rows="7"
          className="code code--embed"
        />
        <button
          type="button"
          className="button button--wide-small button--copy-embed"
          onClick={event => this.copyHandler(code)}
        >
          COPY TO CLIPBOARD
        </button>
      </div>
    )
  }
}

export default withBackend(Code)



// WEBPACK FOOTER //
// ./src/components/Code/Code.js